import React, { useState, useEffect } from 'react';
import Card from '../../common/Card';
import { testimonialsService } from '../../../services/testimonialsService';
import './Testimonials.css';

const StarIcon = ({ filled }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill={filled ? '#fbbf24' : 'none'}
    stroke={filled ? '#fbbf24' : '#d1d5db'}
    strokeWidth="2"
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTestimonials = async () => {
      try {
        const data = await testimonialsService.getFeatured(6);
        setTestimonials(data);
      } catch (error) {
        console.error('Error loading testimonials:', error);
      } finally {
        setLoading(false);
      }
    };

    loadTestimonials();
  }, []);

  if (loading) {
    return (
      <section className="section testimonials">
        <div className="container">
          <div className="testimonials__header text-center">
            <h2>What Our Clients Say</h2>
            <p className="testimonials__subtitle">
              Real stories of transformation and healing
            </p>
          </div>
          <div className="testimonials__loading">Loading testimonials...</div>
        </div>
      </section>
    );
  }

  if (testimonials.length === 0) {
    return null;
  }

  return (
    <section className="section testimonials">
      <div className="container">
        <div className="testimonials__header text-center">
          <h2>What Our Clients Say</h2>
          <p className="testimonials__subtitle">
            Real stories of transformation and healing
          </p>
        </div>

        <div className="testimonials__grid">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="testimonial-card" variant="beige">
              <div className="testimonial-quote">"</div>
              {testimonial.rating && (
                <div className="testimonial-rating">
                  {[...Array(5)].map((_, i) => (
                    <StarIcon key={i} filled={i < testimonial.rating} />
                  ))}
                </div>
              )}
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-author">
                <p className="testimonial-name">{testimonial.name || testimonial.author}</p>
                {testimonial.source === 'google' && (
                  <span className="testimonial-source">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                    </svg>
                    Google Review
                  </span>
                )}
                {testimonial.service && (
                  <p className="testimonial-service">{testimonial.service}</p>
                )}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
